import axios from "axios";

export const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://limo-server-404607.uc.r.appspot.com/",
  // baseURL: process.env.REACT_APP_API_URL || "http://localhost:4000/",
});


// ─── Trip / Reservation ─────────────────────────────
export const getReservationAPI = (resId, isTrip) => {
  if (isTrip) {
    return API.get(`/trip/trip-customer/${resId}`);
  } else {
    return API.get(`/reservation/reservation/${resId}`);
  }
};

export const DownloadReservationAPI = (resId, isTrip) => {
  if (isTrip) {
    return API.get(`/trip/trip-customer-download/${resId}`, {
      responseType: 'blob',
    });
  } else {
    return API.get(`/reservation/reservation/${resId}`, {
      responseType: 'blob',
    });
  }
};

// ─── Invoice ─────────────────────────────────────────
export const getInvoiceDetailsByIdAPI = (invoiceId) => {
  return API.get(`/invoice/invoice-details/${invoiceId}`);
};

export const chargeInvoiceAPI = (data) => {
  return API.post(`/invoice/charge-customer`, data);
};

export const DownloadInvoiceAPI = (invoiceId) => {
  return API.get(`/invoice/invoice-summary/${invoiceId}`, {
    responseType: 'blob',
  });
};

// ─── Payments ────────────────────────────────────────
export const processPaymentAPI = (tripId, amount, paymentMethodId) => {
  return API.get(`/invoice/customer-pay/${tripId}/${amount}/${paymentMethodId}`);
};

// ─── Feedback ────────────────────────────────────────
export const addTripReviewAPI = (data) =>
  API.post(`/trip-feedback/add-review`, data);

export const getCompanyDetailsAPI = (tripId) => {
  return API.get(`/trip-feedback/get-company-from-trip/${tripId}`);
};

// ─── Email ───────────────────────────────────────────
export const sendTripSummaryEmailAPI = (tripId) => {
  return API.post(`/trip/send-trip-summary/${tripId}`);
};

export const sendInvoiceSummaryEmailAPI = (invoiceId) => {
  return API.post(`/invoice/send-invoice-summary/${invoiceId}`);
};
